import * as React from "react";
import Pane from "../Pane";
var ModalBody = function (_a) {
    var children = _a.children, _b = _a.padding, padding = _b === void 0 ? true : _b;
    return (React.createElement("section", { className: "wds-modal__body" },
        React.createElement(Pane, { padding: padding, transparent: true }, children)));
};
export default ModalBody;
//# sourceMappingURL=ModalBody.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/Modal/ModalBody.js
// module id = 1798
// module chunks = 17